import { Button, ButtonProps } from '@synoptic/ui-kit/button/button.tsx';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.tsx';
import { SoundHighIcon } from '@synoptic/ui-kit/icons/react/sound-high.tsx';
import { SoundOffIcon } from '@synoptic/ui-kit/icons/react/sound-off.tsx';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { clsx } from 'clsx';
import { FC } from 'react';
import { soundButton } from '@/components/toggle-sound/sound-button.css.ts';
import { SoundStatus } from '@/components/toggle-sound/sound-status.ts';

export const SoundButton: FC<
  ButtonProps & {
    soundStatus: SoundStatus;
  }
> = ({ soundStatus, onClick, className }) => {
  const isTablet = useIsTablet();

  return (
    <Button
      startIcon={
        soundStatus === SoundStatus.on ? <SoundHighIcon /> : <SoundOffIcon />
      }
      size={isTablet ? 'medium' : 'small'}
      variant={'secondary'}
      onClick={onClick}
      className={clsx(soundButton, className)}
    >
      Sound {soundStatus === SoundStatus.on ? 'on' : 'off'}
    </Button>
  );
};

export const SoundIconButton: FC<
  ButtonProps & {
    soundStatus: SoundStatus;
  }
> = ({ soundStatus, onClick, className, ...props }) => {
  return (
    <IconButton
      size={'small'}
      variant={'secondary'}
      onClick={onClick}
      className={className}
      {...props}
    >
      {soundStatus === SoundStatus.on ? <SoundHighIcon /> : <SoundOffIcon />}
    </IconButton>
  );
};
